// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel.js';
import type { EntlibFailureEServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel } from './entlibFailureEServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel.js';
import type { EntlibResponseEServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel } from './entlibResponseEServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyV1TripleCheckTransactionSearchResponse {
    'data': Array<EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel>;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyV1TripleCheckTransactionSearchResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "Array<EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel>"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyV1TripleCheckTransactionSearchResponse.attributeTypeMap;
    }
}
